/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minValue: NonNullable<unknown> }} Brave_Quiet_Eagle_SoarInputs */

const en_brave_quiet_eagle_soar = /** @type {(inputs: Brave_Quiet_Eagle_SoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.minValue}`)
};

const de_brave_quiet_eagle_soar = /** @type {(inputs: Brave_Quiet_Eagle_SoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab ${i?.minValue}`)
};

/**
* | output |
* | --- |
* | "From {minValue}" |
*
* @param {Brave_Quiet_Eagle_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const brave_quiet_eagle_soar = /** @type {((inputs: Brave_Quiet_Eagle_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Quiet_Eagle_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brave_quiet_eagle_soar(inputs)
	return de_brave_quiet_eagle_soar(inputs)
});